import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainComponent } from './main.component';
import { CoreModule } from '../core.module';
import { RouterModule } from '@angular/router';
import { SidenavComponent } from '../sidenav/sidenav.component';
import { ToolbarModule } from '../toolbar/toolbar.module';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    RouterModule,
    ToolbarModule
  ],
  declarations: [
    MainComponent,
    SidenavComponent
  ],
  exports: [
    MainComponent
  ]
})
export class MainModule { }
